import LzPagePanel from './page-panel.vue';

LzPagePanel.install = function(Vue) {
  Vue.component(LzPagePanel.name, LzPagePanel);
};

export default LzPagePanel;